import app from '@/js/app.js';
import store from '@/store/index.js';
import notify from '@/js/helpers/notify.js';
import apiRequest from '@/js/helpers/apiRequest.js';

const requestLessonName = ({ lessonId, name, lastName }) => {
  app.$f7.dialog
    .create({
      title: `Consultation with user ${lastName} ${name} is over.`,
      content: `
        <div class="view">
          <form class="dialog-form">
            <div class="list no-hairlines">
              <ul>
                <span class="dialog-form-label">Please enter a consultation name*</span>
                <li class="item-content item-input">
                  <div class="item-inner">
                    <div class="item-input-wrap">
                      <input type="text" name="name" placeholder="Consultation name">
                      <span class="input-clear-button"></span>
                    </div>
                  </div>
                </li>

                <span class="dialog-form-label">Please rate consultation*</span>
                <li>
                  <label class="item-radio item-content">
                    <input type="radio" name="rateStudent" value="A" checked />
                    <i class="icon icon-radio"></i>
                    <div class="item-inner">
                      <div class="item-title">A</div>
                    </div>
                  </label>
                </li>
                <li>
                  <label class="item-radio item-content">
                    <input type="radio" name="rateStudent" value="B" />
                    <i class="icon icon-radio"></i>
                    <div class="item-inner">
                      <div class="item-title">B</div>
                    </div>
                  </label>
                </li>
                <li>
                  <label class="item-radio item-content">
                    <input type="radio" name="rateStudent" value="C" />
                    <i class="icon icon-radio"></i>
                    <div class="item-inner">
                      <div class="item-title">C</div>
                    </div>
                  </label>
                </li>
                <li>
                  <label class="item-radio item-content">
                    <input type="radio" name="rateStudent" value="D" />
                    <i class="icon icon-radio"></i>
                    <div class="item-inner">
                      <div class="item-title">D</div>
                    </div>
                  </label>
                </li>
                <li>
                  <label class="item-radio item-content">
                    <input type="radio" name="rateStudent" value="F" />
                    <i class="icon icon-radio"></i>
                    <div class="item-inner">
                      <div class="item-title">F</div>
                    </div>
                  </label>
                </li>
              </ul>
            </div>
          </form>
        </div>
        `,
      buttons: [
        {
          text: 'Send',
          color: 'green',
          keyCodes: [13],
          onClick: async dialog => {
            const form = app.$$('.dialog-form')[0];
            const body = new FormData(form);

            for (let item of body.entries()) {
              if (item[0] === 'name' && item[1].length) {
                try {
                  body.append('lesson_id', lessonId);

                  const res = await apiRequest('lesson/setname', 'POST', body, true);

                  if (res.error) {
                    notify({ text: res.error });
                    requestLessonName({ lessonId, name, lastName });
                    return;
                  }

                  dialog.destroy();
                  return;
                } catch (error) {
                  notify({
                    text: 'Something went wrong 🤯. Please try again.'
                  });
                  console.error('lesson/setname ERROR:', error);
                }
              } else {
                requestLessonName({ lessonId, name, lastName });
                return;
              }
            }
          }
        }
      ]
    })
    .open();
};

const questionMessage = {
  id: null,
  answers: [],
  isQuestion: true,
  type: 'sent',
  date: '',
  userId: null,
  title: '',
  text: '',
  image: null,
  audioList: [],
  videoList: [],
  attachment: null
};

const requestAction = (res = {}) => {
  if (!Object.keys(res).length) return;

  const { action } = res;

  switch (action) {
    case 'add': {
      const {
        request: { id, language_id, level_id, start },
        user
      } = res.data;

      const requests = {
        id,
        start,
        languageId: language_id,
        levelId: level_id,
        user
      };

      store.commit('request/SET_REQUEST', requests);
      break;
    }

    case 'remove':
    case 'cancel': {
      const {
        request: { id }
      } = res.data;

      store.commit('request/REMOVE_REQUEST', { id });
      break;
    }
  }
};

const userAction = (res = {}) => {
  if (!Object.keys(res).length) return;

  const { action } = res;

  switch (action) {
    case 'new_message': {
      const {
        id,
        mark,
        quote,
        quote_date,
        lesson_id,
        created_at,
        user_id,
        text,
        attachments
      } = res.data;

      const message = {
        id,
        isQuestion: false,
        type: user_id === store.state.user.info.id ? 'sent' : 'received',
        mark,
        quote,
        quoteDate: quote_date,
        date: created_at,
        userId: user_id,
        text,
        attachment:
          attachments && attachments.length
            ? {
                src: attachments[0].src,
                name: attachments[0].name,
                type: attachments[0].type,
                size: attachments[0].size
              }
            : null
      };

      store.commit('lesson/SET_MESSAGE', { message, lessonId: lesson_id });
      break;
    }

    case 'new_question': {
      const { answers, body, id, created_at, name, video, image, audio } = res.data;

      // const audioList = JSON.parse(audio);
      // const videoList = JSON.parse(video);

      if (body) {
        store.commit('lesson/SET_MESSAGE', {
          message: { ...questionMessage, id, text: body, date: created_at },
          lessonId: store.state.lesson.currentLessonId
        });
      }

      if (answers.items.length) {
        store.commit('lesson/SET_MESSAGE', {
          message: {
            ...questionMessage,
            id,
            date: created_at,
            answers: answers.items
          },
          lessonId: store.state.lesson.currentLessonId
        });
      }
      break;
    }

    case 'message_marked': {
      const { lesson_id: lessonId, message_id: messageId, mark } = res.data;

      store.commit('lesson/SET_MESSAGE_MARK', {
        lessonId,
        messageId,
        mark
      });

      break;
    }

    case 'lesson_booked': {
      const {
        booking: { id, start, level_id, language_id }
      } = res.data;
      store.commit('user/SET_BOOKING', [
        {
          id,
          start,
          levelId: +level_id,
          languageId: +language_id
        }
      ]);

      break;
    }

    case 'lesson_start': {
      const {
        lesson: { id, start, video, messages },
        user
      } = res.data;

      const lesson = {
        id,
        start,
        video,
        user,
        messages:
          messages && messages.length
            ? messages.map(({ id, created_at, user_id, text }) => ({
                id,
                type: user_id === store.state.user.info.id ? 'sent' : 'received',
                date: created_at,
                userId: user_id,
                text
              }))
            : []
      };

      store.commit('lesson/SET_LESSON', { lesson });
      break;
    }

    case 'new_proofread': {
      store.dispatch('proofread/getProofreads');
      break;
    }

    case 'lesson_end':
    case 'not_enough_money_to_lesson':
    case 'lesson_end_time': {
      const {
        id,
        user: { name, last_name: lastName }
      } = res.data;

      requestLessonName({ lessonId: id, name, lastName });

      if (+app.$f7.views.main.router.currentRoute.params.id === id) {
        app.$f7.views.main.router.navigate(`/`, {
          clearPreviousHistory: true
        });
      }

      const { video } = store.state.lesson.lessons.find(lesson => lesson.id === id);

      notify({ text: res.data.message });

      app.$nextTick(() => {
        store.commit('lesson/FINISH_LESSON', { id, video });
      });

      break;
    }
  }
};

export { requestAction, userAction };
